var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page-title"},[_vm._v("報告")]),_c('div',{staticClass:"page-box"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"item-text",on:{"click":function($event){return _vm.onClicked(item.path)}}},[_vm._v(" "+_vm._s(item.title)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }